// extracted by mini-css-extract-plugin
export var indeterminate = "_4o-6";
export var md = "_4o-5";
export var semantic = "_4o-7";
export var sm = "_4o-4";
export var text = "_4o-8";
export var toggleControl = "_4o-0";
export var toggleInput = "_4o-1";
export var toggleSwitch = "_4o-2";
export var xs = "_4o-3";